module.exports = __webpack_public_path__ + "static/img/icon19.976d5a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon19.png
// module id = 3zy/
// module chunks = 0